"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MainPageTilesImpl = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var coreHttp = _interopRequireWildcard(require("@azure/core-http"));

var Mappers = _interopRequireWildcard(require("../models/mappers"));

var Parameters = _interopRequireWildcard(require("../models/parameters"));

/*
 * Copyright (c) Microsoft Corporation.
 * Licensed under the MIT License.
 *
 * Code generated by Microsoft (R) AutoRest Code Generator.
 * Changes may cause incorrect behavior and will be lost if the code is regenerated.
 */

/** Class containing MainPageTiles operations. */
var MainPageTilesImpl = /*#__PURE__*/function () {
  /**
   * Initialize a new instance of the class MainPageTiles class.
   * @param client Reference to the service client
   */
  function MainPageTilesImpl(client) {
    (0, _classCallCheck2["default"])(this, MainPageTilesImpl);
    this.client = client;
  }
  /**
   * @param portalId
   * @param options The options parameters.
   */


  (0, _createClass2["default"])(MainPageTilesImpl, [{
    key: "get",
    value: function get(portalId, options) {
      var operationArguments = {
        portalId: portalId,
        options: coreHttp.operationOptionsToRequestOptionsBase(options || {})
      };
      return this.client.sendOperationRequest(operationArguments, getOperationSpec);
    }
  }]);
  return MainPageTilesImpl;
}(); // Operation Specifications


exports.MainPageTilesImpl = MainPageTilesImpl;
var serializer = new coreHttp.Serializer(Mappers,
/* isXml */
false);
var getOperationSpec = {
  path: "/api/Portals({portalId})/Tiles",
  httpMethod: "GET",
  responses: {
    200: {
      bodyMapper: {
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "TileDto"
            }
          }
        }
      }
    }
  },
  urlParameters: [Parameters.$host, Parameters.portalId],
  headerParameters: [Parameters.accept],
  serializer: serializer
};